var p={chip:"rl2_Chip-module_chip_gFkbn"};export{p as default};
